<template>
  <div class="forward-report" v-if="loaded">
    <vue-headful title="Forward Document" />
    <ViewComponentLoader v-if="apiLoading" label="Loading your Forward Defaults" />
    <hg-forward-document-form
      v-if="apiLoaded"
      :hg-forward-defaults="forwardDefaults"
      @forward="forward" />
  </div>
</template>

<script>
import { mapState } from 'vuex';

import BaseViewComponent from '@/components/Shared/BaseViewComponent.vue';
import ViewComponentLoader from '@/components/Shared/ViewComponentLoader.vue';
import ForwardDocumentForm from '../Forward/ForwardDocumentForm.vue';

export default {
  extends: BaseViewComponent,
  components: {
    'hg-forward-document-form': ForwardDocumentForm,
    ViewComponentLoader,
  },
  mounted() {
    this.initialHydration([
      this.$store.dispatch('Documents/loadForwardDefaults', this.reportId),
    ]);
  },
  data() {
    return {
      loaded: true,
    };
  },
  props: {
    reportId: {
      type: String,
      required: true,
    },
    folderId: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapState('Documents', {
      forwardDefaults: state => state.forwardDefaults,
    }),
  },
  beforeRouteUpdate(to, from, next) {
    if (!to.hash) { /* ignore anchor tags for scrolling */
      this.load(to.params.reportId);
      next();
    }
  },
  methods: {
    async forward(forwardData) {
      const data = this.prepData(forwardData);

      this.forwardComplete = false;
      const result = await this.$store.dispatch('Documents/forwardDocument', data);
      if (result) {
        this.$router.push({
          name: 'inspection',
          params: {
            folderId: this.folderId,
            forwardedRecipients: result.to,
            forwardComplete: true,
          },
        });
      }
    },
    prepData(forwardData) {
      const data = forwardData;
      delete data.canForward;
      return data;
    },
    async load(id) {
      this.loaded = false;
      await this.$store.dispatch('Documents/loadForwardDefaults', id);
      this.loaded = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.forward-report {
  padding: 50px;
}
</style>
